import { authorizedFetch } from './httpClient';

const API_URL = process.env.REACT_APP_API_URL;

export interface UserInfo {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

export const getMe = async (): Promise<UserInfo> => {
  const response = await authorizedFetch(`${API_URL}/api/users/me`);
  if (!response.ok) throw new Error('Failed to fetch user info');
  return response.json();
};
